import React, { useState } from "react";
import PropTypes from "prop-types";
import { FiTruck, FiChevronUp, FiChevronDown } from "react-icons/fi";

import {
  AccordionHeader,
  AccordionLabel,
  Chevron,
  AccordionContent,
  DataText,
  AlterLink,
} from "../styles";

function formatAddress(address) {
  if (!address || !Object.keys(address).length) return "";
  const streetName = address.streetName || address.address_line1 || "";
  const number = address.number || "";
  const complement = address.complement || address.address_line3 || "";
  const neighborhood = address.neighborhood || address.address_line2 || "";
  const city = address.city || "";
  const state = address.state || "";
  const zip = address.zipCode || address.cep || "";

  const street = [streetName, number].filter(Boolean).join(", ");
  const neighborhoodLine = neighborhood;
  const cityState = [city, state].filter(Boolean).join(" - ");
  const cepFormatted = zip;

  return [street, complement, neighborhoodLine, cityState, cepFormatted]
    .filter(Boolean)
    .join(" - ");
}

export default function DeliveryAddressAccordion({ address, onAlterar }) {
  const [open, setOpen] = useState(true); // inicia aberto (spec)
  const formatted = formatAddress(address);

  return (
    <div>
      <AccordionHeader type="button" onClick={() => setOpen((v) => !v)}>
        <AccordionLabel>
          <FiTruck />
          Endereço de entrega
        </AccordionLabel>
        <Chevron>{open ? <FiChevronUp /> : <FiChevronDown />}</Chevron>
      </AccordionHeader>

      {open && (
        <AccordionContent>
          <DataText>
            {formatted || "Nenhum endereço selecionado"}
          </DataText>
          <AlterLink onClick={onAlterar}>Alterar</AlterLink>
        </AccordionContent>
      )}
    </div>
  );
}

DeliveryAddressAccordion.propTypes = {
  address: PropTypes.object,
  onAlterar: PropTypes.func,
};
